__turbopack_context__.v({
  "qr": "Intro-module__lhA7fW__qr",
});
